export default __webpack_public_path__ + "media/images/portfolio/gallery-07-370x220-46f977480458374c474aba75c737eda6.jpg";